<template lang="pug">
    .slider(v-if="slides && slides.length" :class="size")
        swiper(
            :options="settings" ref="swiper"
            @slideChange="slideChange"
        )
            swiper-slide(v-for="slide in slides" :key="slide.id")
                Slide(:slide="slide" :image-loaded="false" ref="slide")
            .swiper-pagination(slot="pagination")
            .swiper-button-prev.swiper-button-black(slot="button-prev")
            .swiper-button-next.swiper-button-black(slot="button-next")
</template>

<script>

// import _ from 'lodash'

import Slide from './Slide'

export default {
    name: 'Slider',
    data() {
        return {
            settings: {
                slidesPerView: 1,
                // spaceBetween: 30,
                preloadImages: false,
                // lazy: true,
                lazy: {
                    // loadPrevNext: true,
                    loadOnTransitionStart: true
                },
                loop: true,
                speed: 1200,
                // autoplay: {
                //     delay: 6000,
                //     disableOnInteraction: false
                // },
                pagination: {
                    el: '.swiper-pagination',
                    // dynamicBullets: true,
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                on: {
                    beforeDestroy: () => {
                        // swiper instance is getting destroyed before the page transition is done
                        // the only working fix is to throw an error to bypass destroying swiper
                        // throw new Error('ignore this error')
                    },
                    // lazyImageLoad: (slide, image) => {
                    //     console.log('load');
                    //     // this.$emit('lazyImageLoad', slide, image)
                    // },
                    // lazyImageReady: (slide, image) => {
                    //     // console.log('ready', this.$refs, slide, image);
                    //     const index = parseInt(slide.getAttribute('data-swiper-slide-index'))
                    //     console.log('ready', index);
                    //     this.$refs.slide[index].imageLoaded = true
                    //     // this.$emit('lazyImageReady', slide, image)
                    // },
                }
            },
        }
    },
    props: {
        // slides: {
        //     type: Array,
        //     default: () => [],
        // },
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Slide,
    },
    computed: {
        slides() {
            let slides = this.section.contents || []
            return _.cloneDeep(slides).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
        },
        swiper() {
            return this.$refs.swiper.swiper
        },
        size() {
            let size = 'full-width'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'size')
                if (setting && setting.value !== undefined) size = setting.value
            }

            return size
        },
    },
    methods: {
        slideChange() {
            // // const event = new Event('animationend')
            // if (this.swiper.progress === -0) {
            //     setTimeout(() => {
            //         // const el = document
            //         const event = document.createEvent('HTMLEvents')
            //         event.initEvent('resize', true, false)
            //         this.swiper.el.dispatchEvent(event)
            //         console.log('shots fired');
            //     }, 300)
            // }
            // console.log('slide change', this.swiper, this.swiper.activeIndex, this.swiper.progress);
        },
    },
    // mounted() {
    //     this.$nextTick(() => {
    //         console.log(this.swiper);
    //     })
    // }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    .slider
        background-color: #eeeeee
        .swiper-button-prev,
        .swiper-button-next
            height: 22px
            bottom: 11px
            top: auto
        .swiper-button-prev
            left: 10px
        +desktop
            .swiper-container
                min-height: 400px
            .swiper-container-horizontal > .swiper-pagination-bullets
                width: calc(50% - 40px)
                left: calc(50% + 20px)
                right: 20px
            .swiper-button-prev
                left: calc(50% + 10px)
            & /deep/ .swiper-pagination-bullet-active
                background: #000000
</style>
